module.exports = __webpack_public_path__ + "img/detailBG-1.0cdff324.jpeg";